import React, { useState } from 'react';

import CabecalhoGraficoMobile from 'components/Windx/Mobile/CabecalhoGrafico';
import FullscreenChart from 'components/Layout/MobileShell/FullscreenChart';
import GraficoSH from 'components/Windx/GraficoSH';

import './index.scss';

/**
 * WEOL-SH no mobile (spec Windx mobile, Task 8).
 *
 * O botao de tela cheia mora no cabecalho do card do grafico
 * (`ChartComSliders`), como no prototipo — antes ele flutuava numa fileira
 * propria acima do grafico, sem moldura. Por isso `onExpandir` so vai na
 * instancia inline: dentro do overlay nao ha o que expandir.
 */
export default function SemiHorarioMobile() {
  const [carregando, setCarregando] = useState(false);
  const [telaCheia, setTelaCheia] = useState(false);

  return (
    <div className="windx-sh-mobile" data-testid="windx-sh-mobile">
      <CabecalhoGraficoMobile tela="sh" carregando={carregando}>
        <div className="windx-sh-mobile-grafico">
          {!telaCheia && (
            <GraficoSH
              onLoadingChange={setCarregando}
              onExpandir={() => setTelaCheia(true)}
            />
          )}
        </div>
      </CabecalhoGraficoMobile>

      <FullscreenChart
        open={telaCheia}
        dismiss={() => setTelaCheia(false)}
        title="WEOL-SH"
        landscape
      >
        {telaCheia && (
          <div className="windx-sh-mobile-fullscreen">
            <GraficoSH onLoadingChange={setCarregando} />
          </div>
        )}
      </FullscreenChart>
    </div>
  );
}
